<h3>
    <i ng-if="item.isProtected" class="fa fa-lock" style="color: gray" title="{{'notification.template.isProtected'|translate}}"></i>
    <a ng-click="viewDetails($event, item)" ng-bind-html="item.text"></a> <span ng-if="item.updated" class="fa fa-check" style="color: green"></span>
</h3>
<div class="property-container">
    <ul class="workflow-property-list">
        <li>{{item.typeDescription}}</li>
        <li ng-if="item.description">{{item.description|localize}}</li>
    </ul>
</div>
